import { Play, Pause, Check, Sparkles } from "lucide-react";

export const MusicRow = ({ track, selected, playing, onSelect, onTogglePlay, suggested }) => (
  <div
    className={`flex items-center gap-3 rounded-xl border p-3 transition-colors cursor-pointer ${selected ? "border-primary bg-primary/10" : "border-border hover:border-primary/50"}`}
    onClick={() => onSelect(track.id)}
    data-testid={`music-row-${track.id}`}
  >
    <button
      onClick={(e) => { e.stopPropagation(); onTogglePlay(track.id); }}
      className="h-9 w-9 shrink-0 rounded-full bg-primary/15 text-primary grid place-items-center hover:bg-primary/25 transition-colors"
      data-testid={`music-play-${track.id}`}
      aria-label={playing ? "Pause" : "Play"}
    >
      {playing ? <Pause size={15} /> : <Play size={15} className="ml-0.5" />}
    </button>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold truncate flex items-center gap-1.5">
        {track.name}
        {suggested && <span className="inline-flex items-center gap-0.5 text-[9px] font-mono text-primary"><Sparkles size={9} /> SUGGESTED</span>}
      </p>
      <p className="text-[11px] text-muted-foreground font-mono">{track.vibe} · {track.bpm} BPM</p>
    </div>
    {selected && <span className="h-5 w-5 shrink-0 rounded-full bg-primary text-primary-foreground grid place-items-center"><Check size={11} strokeWidth={3} /></span>}
  </div>
);
